import Vue from 'vue/dist/vue.esm.js'

KCVS.Views.InformativeFieldsForm = Vue.extend(
  data: ->
    filterValue: ''
    translatedFilterValue: ''
    filterValueInput: ''
    informativeFields: {}
    inputFieldNameInputValue: ''
    inputFieldNameInputCollection: null
    reportDocumentGroupIds: []
    showGroupInput: false

  methods:
    populateSelectOptions: (selectElement, selectElementValue, inputFieldNameInputCollectionValue, inputFieldNameInput) ->
      @filterValue = inputFieldNameInputCollectionValue
      @translatedFilterValue = I18n.t("admin.informative_fields.input_fields.conditions.#{inputFieldNameInputCollectionValue}")

      switch inputFieldNameInputCollectionValue
        when 'document_group_filter'
          filterValues = @reportDocumentGroupIds
        else return

      selectElement.innerHTML = ''
      blankOption = document.createElement('option')
      selectElement.appendChild(blankOption)

      informativeFieldFilters = @informativeFields.map (field) ->
        if field.input_field_name == inputFieldNameInput and field.filter == inputFieldNameInputCollectionValue
          return field.filter_value

      for value in filterValues
        if selectElementValue == String(value[1]) || !informativeFieldFilters.includes(String(value[1]))
          option = document.createElement('option')
          option.value = value[1]
          option.textContent = value[0]
          selectElement.appendChild(option)

  mounted: ->
    if @inputFieldNameInputValue && @inputFieldNameInputCollection[@inputFieldNameInputValue] != 'no_filter'
      @showGroupInput = true
      @$nextTick =>
        @populateSelectOptions(
          @$refs.filterValueInput,
          @filterValueInput,
          @inputFieldNameInputCollection[@inputFieldNameInputValue],
          @inputFieldNameInputValue
        )
        @$nextTick =>
          @$refs.filterValueInput.value = @filterValueInput

  watch:
    inputFieldNameInputValue: (newVal, oldVal) ->
      if @inputFieldNameInputCollection[newVal] != 'no_filter'
        @showGroupInput = true
        @.$nextTick ->
          @populateSelectOptions(
            @.$refs.filterValueInput,
            @filterValueInput,
            @inputFieldNameInputCollection[newVal],
            newVal
          )
      else
        @showGroupInput = false
)